const messages = {
    dashboard: {
        title: "Tableau de bord",
        extraTitle: "TABLEAU DE BORD",
        description:
            "Bienvenue sur votre tableau de bord. Ici, vous pouvez consulter les chiffres et les entreprises participantes de votre base clients.",
        overview: {
            title: "Aperçu des clients participants",
            description:
                "Entreprises qui se sont inscrites à BRIDGESTONE PLUS et que nous pouvons attribuer à vos entreprises grâce à leur numéro de client.",
            month: "Nouveau ce mois-ci",
            year: "Nouveau cette année",
            all: "Total",
        },
        credits: {
            title: "Crédits de points {name}",
            description:
                "Points de récompense attribués aux entreprises participantes sur la base des chiffres de vente que vous avez téléchargés. Dans cette vue, les points réguliers sont affichés sans les promotions.",
            month: "Dernier mois",
            year: "Année en cours",
            prev_year: "Total",
            allDealers: "Tous les points des commerçants",
        },
        details: {
            title: "Détail des clients participants",
            description:
                'Vous trouverez ci-dessous les entreprises qui se sont enregistrées sur BRIDGESTONE <span class="text-danger">PLUS</span> avec un numéro de client {name} et qui vous ont été attribuées en tant que responsable. Utilisez simplement les fonctions de tri pour obtenir un autre ordre ou utilisez le champ de recherche.',
        },
        lastImport:
            'Dernière importation des chiffres de vente : <br/> <span class="text-danger">{date}</span>',
        loadMore: "Charger 20 commerçants supplémentaires",
        tyres: {
            title: "Pneus",
            description: "Pneus achetés par les participants au programme",
        },
    },
};

export default {
    messages,
};
